module.exports = __webpack_public_path__ + "static/media/ourStory.e3204da6.svg";